// src/pages/TestOne.js
import React, { useState, useEffect } from 'react';
import { Card, Button, Spinner, ProgressBar } from 'react-bootstrap';
import 'animate.css/animate.min.css';
import { useNavigate } from 'react-router-dom';
import api from "../api.js";

const TestOne = () => {
  const [started, setStarted] = useState(false);
  const [scenarios, setScenarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentScenarioIndex, setCurrentScenarioIndex] = useState(0);
  const [currentStage, setCurrentStage] = useState(1);
  const [responses, setResponses] = useState({});
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

  // Fetch test data on mount
  useEffect(() => {
    api.get(`${API_BASE_URL}/test1/scenarios`)
      .then((res) => {
        setScenarios(res.data.scenarios);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching test scenarios:", err);
        setLoading(false);
      });
  }, []);

  const handleStart = () => {
    setStarted(true);
  };

  const handleAnswer = (answer) => {
    const currentScenario = scenarios[currentScenarioIndex];
    const scenarioNum = currentScenario.scenario_number;
    // Record the answer for the current stage (e.g., "scenario1_stage1")
    setResponses(prev => ({
      ...prev,
      [`scenario${scenarioNum}_stage${currentStage}`]: answer
    }));

    if (currentStage === 1) {
      setCurrentStage(2);
    } else if (currentStage === 2) {
      setCurrentStage(3);
    } else if (currentStage === 3) {
      // Finished the current scenario; move to next or submit if last scenario
      if (currentScenarioIndex < scenarios.length - 1) {
        setCurrentScenarioIndex(currentScenarioIndex + 1);
        setCurrentStage(1);
      } else {
      // Retrieve the user_id from localStorage (or another source)
      const userId = Number(localStorage.getItem("user_id"));

      // When submitting the test, include the "id" field along with responses.
      api.post(`${API_BASE_URL}/test1/submit`, { 
        id: userId,
        responses 
      })
      .then(response => {
        console.log("Final scores:", response.data.final_scores);
        alert("Test Complete! Redirecting to your dashboard.");
        navigate('/dashboard');
      })
      .catch(error => {
        console.error("Error submitting test responses:", error);
      });
      }
    }
  };

  // Calculate progress percentage:
  // Total steps = number of scenarios * 3 (stages per scenario)
  // Current step = (currentScenarioIndex * 3) + (currentStage - 1) + 1
  const totalSteps = scenarios.length * 3;
  const currentStep = currentScenarioIndex * 3 + (currentStage - 1) + 1;
  const progressPercent = Math.round((currentStep / totalSteps) * 100);


  const renderStage = () => {
    if (!started) {
      return (
        <Card className="animate__animated animate__fadeIn">
          <Card.Body>
            <Card.Title>The Overview Test</Card.Title>
            <Card.Text>
              This test will guide you through a rich and engaging story that will allow Vybly to get to know you and better serve you based on your answers. Each questions has two to three answers to choose from. Your responses will be evaluated at the end of the test.:
              <br /><br />
              Choose the answers based on how you would act in this story.
              <br /><br />
              Click "Start" to begin.
            </Card.Text>
            <Button onClick={handleStart}>Start</Button>
          </Card.Body>
        </Card>
      );
    } else if (scenarios.length === 0) {
      return <div>No scenarios available.</div>;
    } else {
      const currentScenario = scenarios[currentScenarioIndex];
      let question;
      if (currentStage === 1) {
        question = currentScenario.stage1;
      } else if (currentStage === 2) {
        // Use the answer from stage1 to select the correct stage2 question.
        const stage1Answer = responses[`scenario${currentScenario.scenario_number}_stage1`];
        question = currentScenario.stage2[stage1Answer];
      } else if (currentStage === 3) {
        question = currentScenario.stage3;
      }
      return (
        <Card className="animate__animated animate__fadeIn">
          <Card.Body>
            <Card.Title><div style={{ whiteSpace: 'pre-wrap' }}>{question.prompt}</div></Card.Title>
            {Object.entries(question.options).map(([key, text]) => (
              <Button
                key={key}
                variant="outline-primary"
                className="m-2"
                onClick={() => handleAnswer(key)}
              >
                {text}
              </Button>
            ))}
          </Card.Body>
        </Card>
      );
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading scenarios...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="container mt-4">
    {/* Progress bar */}
    {started && (
      <ProgressBar 
        now={progressPercent} 
        label={`${progressPercent}%`} 
        className="mb-3" 
        variant="info"
      />
    )}
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
      {renderStage()}
    </div>
    </div>
  );
};

export default TestOne;
